/**
 * AGC: Hook to check backend server connection status
 * AGC: Polls the backend health endpoint to verify server is online
 */

import { useEffect, useState } from 'react'
import { buildBackendUrl } from '../utils/backendUrl'

export const useBackendStatus = () => {
  const [isOnline, setIsOnline] = useState(false)
  const [isChecking, setIsChecking] = useState(true)

  useEffect(() => {
    // AGC: Always use HTTPS for Android/mobile compatibility (no HTTP fallback)
    const checkStatus = async () => {
      try {
        const response = await fetch(buildBackendUrl('health'), {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          },
          signal: AbortSignal.timeout(5000) // 5 second timeout
        })
        
        if (response.ok) {
          setIsOnline(true)
        } else {
          setIsOnline(false)
        }
      } catch (error) {
        setIsOnline(false)
      } finally {
        setIsChecking(false)
      }
    }

    // AGC: Check immediately
    checkStatus()

    // AGC: Check every 10 seconds
    const interval = setInterval(checkStatus, 10000)

    return () => clearInterval(interval)
  }, [])

  return { isOnline, isChecking }
}

